
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FirestoreService } from './firestore-service.service';
//import { GoogleGenAI } from "@google/genai";
import { getAuth, User } from 'firebase/auth';

// Define the types that match your Firebase Function's input/output
// These should mirror the types in your Firebase Function

export interface ChatMessagePart {
  text: string;
}

export interface ChatMessage {
  role: 'user' | 'model';
  parts: ChatMessagePart[];
}

export interface GeminiRequestData {
  prompt: string;
  history?: ChatMessage[];
  enableGoogleSearchGrounding?: boolean;
  // urlContext?: string[]; // If you add this to your function
}

export interface GeminiResponseData {
  responseText: string;
  updatedHistory: ChatMessage[];
  // citationMetadata?: any; // If you plan to use this
}


@Injectable({
  providedIn: 'root',
})
export class GeminiService {
 // private functions: Functions = inject(Functions); // Angular 14+ inject

  constructor(private http: HttpClient, private firestore: FirestoreService) {
    // For older Angular versions, inject via constructor:
    // constructor(private functions: Functions) {}
  }

  getToken() {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (currentUser) {
      return currentUser.getIdToken()
    } else {
      return null
    }
  }

  async getGeminiEmbeddings(input: {key: string, chunk: string}[]) {
    const idToken = await this.getToken();
    if (idToken) {
      const body = {
          input: input,
          model: "gemini-embedding-001",
      }
      const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`  // Include the ID token in the Authorization header
      }
      try {
        const response = await fetch('https://europe-west1-lessons-learned-fd280.cloudfunctions.net/createEmbeddingGemini', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });
        if (!response.ok) { // Check if the HTTP status code is in the 200-299 range
            const errorText = await response.text(); // Get more details about the error
            console.error('HTTP Error:', response.status, errorText);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data
        // ... do something with data
    } catch (error) {
        console.error("Fetch or processing error:", error);
        return []
        // Handle the error (e.g., show a user message)
    }
  }
}

  async getGeminiResponseSimple(organizationKey: string, projectKey: string, userId: string, prompt: string, llmLimit: number, enableGoogleSearchGrounding: boolean = true, modelKey: string = "gemini-2.5-flash", temperature: number = 0)  {
    if (llmLimit <= 0) {
      return {responseText: "You have no more LLM requests left. Please upgrade your plan.", updatedHistory: [], isError: true, errorType: "llmLimit"}
    }
    const data: GeminiRequestData = {
      prompt: prompt,
      history: [],
      enableGoogleSearchGrounding: enableGoogleSearchGrounding
    }
    
    return await this.getGeminiResponse(data, organizationKey, projectKey, userId, llmLimit, enableGoogleSearchGrounding, modelKey, temperature)
  }

  async getGeminiResponse(data: GeminiRequestData, organizationKey: string, projectKey: string, userId: string, llmLimit: number, enableGoogleSearchGrounding: boolean = true, modelKey: string = "gemini-2.5-flash", temperature: number = 0)  {
    if (llmLimit <= 0) {
      return {responseText: "You have no more LLM requests left. Please upgrade your plan.", updatedHistory: [], isError: true, errorType: "llmLimit"}
    }

    if (modelKey == "gemini-3-pro-preview" && enableGoogleSearchGrounding == true) { // search grounding odesn't work with gemini-3-pro-preview
      modelKey = "gemini-2.5-pro"
    }

    const result: any = await new Promise(resolve => {
      const body = {
        prompt: data.prompt,
        history: data.history,
        modelKey: modelKey,
        organizationKey: organizationKey,
        projectKey: projectKey,
        enableGoogleSearchGrounding: enableGoogleSearchGrounding,
        temperature: temperature
      }

      return this.http.post("https://europe-west1-lessons-learned-fd280.cloudfunctions.net/geminiWithGrounding2", body).subscribe({
        next: (response: any) => {
          const result: string = response.responseText
          const groundingMetadata = response.groundingMetadata || {}
          const sources: [] = groundingMetadata.groundingChunks || []
          const res: any = {
            responseText: result,
            sources: sources
          }
          this.firestore.decrementUserLLMLimits(userId)
          resolve(res)
        },
        error: (e) => {
          console.error(e)
          resolve("error")
        }
      });
    })
    return result
  }


}